export const translateToIcon = inputurl => {
  return new Promise(resolve => {
    const canvas = document.createElement("canvas");
    canvas.width = 64;
    canvas.height = 64;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.setAttribute("crossOrigin", "anonymous");
    img.onload = function () {
      const width = img.width;
      const height = img.height;
      const ratio = width / height;
      const x = ratio >= 1 ? 0 : (64 - 64 * ratio) / 2;
      const y = ratio >= 1 ? (64 - 64 / ratio) / 2 : 0;
      try {
        ctx.drawImage(img, x, y, ratio >= 1 ? 64 : 64 * ratio, ratio >= 1 ? 64 / ratio : 64);
        resolve(canvas.toDataURL("image/png", 1));
      } catch (e) {
        // 图标域名缺少 CORS 响应头时画布被污染，导出会抛 SecurityError，交给外层兜底图标
        resolve(undefined);
      }
    };
    img.onerror = function () {
      resolve(undefined);
    };
    img.src = inputurl + "?time=" + new Date().valueOf();
  });
};
